import { StarIcon } from "@heroicons/react/16/solid";
import { ForwardedRef, forwardRef } from "react";
import { FieldError } from "react-hook-form";

interface TTextInputBaseProps extends React.ComponentPropsWithRef<"input"> {
  label?: string;
  icon?: React.ReactNode;
  error?: FieldError;
  containerClass?: string;
  isRequired?: boolean;
}

const TextInputBase = forwardRef<HTMLInputElement, TTextInputBaseProps>(
  (
    { label, icon, error, containerClass, isRequired, ...rest },
    ref: ForwardedRef<HTMLInputElement>
  ) => {
    TextInputBase.displayName = "TextInputBase";
    const isError = error?.message ? true : false;
    return (
      <div className={`flex flex-col w-full ${containerClass}`}>
        {label && (
          <label className="text-xs flex items-center gap-1 text-left text-body font-semibold pl-1">
            {label}
            {isRequired && (
              <StarIcon className="size-2 text-error -translate-y-1" />
            )}
          </label>
        )}
        <section className="w-full relative">
          <input
            {...rest}
            ref={ref}
            autoComplete="off"
            className={`h-10 w-full text-sm text-body font-semibold px-3 py-1 border-2 border-extraLightGray
            placeholder:font-medium placeholder:text-darkGray/80 outline-none  rounded-lg z-10
            disabled:bg-extraLightGray/30 disabled:opacity-70 disabled:cursor-not-allowed focus:border-primary/50 ${rest.className}`}
          />

          <span
            className={`${
              isError ? "text-error" : "text-darkGray/80"
            } absolute w-5 right-3 top-1/2 -translate-y-1/2 `}
          >
            {icon}
          </span>
        </section>
        {isError && (
          <p className="text-xs text-error/90 font-medium pl-1 ">
            {error?.message}
          </p>
        )}
      </div>
    );
  }
);

export default TextInputBase;
